/**
 * HUB-D — Carte ligne mensuelle caisse (responsive).
 */
import React from 'react';
import MagasinBadge from '../MagasinBadge';
import { ecartClass, formatEuro } from '../../utils/caisse/caisseDisplay';

export default function ActiviteCaisseMonthlyCard({ row, actions, testIdPrefix = 'activite-caisse' }) {
  return (
    <article
      className="rounded-xl border p-4 space-y-3"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid={`${testIdPrefix}-monthly-${row.id}`}
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <span className="font-bold text-[var(--rm-white)]">{row.date_caisse}</span>
          <MagasinBadge code={row.magasin_id || 'M1'} size="sm" />
        </div>
        <span className={`font-bold ${ecartClass(row.ecart)}`}>{formatEuro(row.ecart)}</span>
      </div>

      <div className="grid grid-cols-2 gap-2 text-sm">
        <div><span className="text-[var(--rm-gray-500)]">Ventes </span><span className="font-semibold text-[var(--rm-success)]">{formatEuro(row.total_ventes)}</span></div>
        <div><span className="text-[var(--rm-gray-500)]">Espèces </span><span className="font-semibold">{formatEuro(row.total_especes)}</span></div>
        <div><span className="text-[var(--rm-gray-500)]">CB </span><span className="font-semibold">{formatEuro(row.total_cb)}</span></div>
        <div><span className="text-[var(--rm-gray-500)]">Stripe </span><span className="font-semibold">{formatEuro(row.total_stripe)}</span></div>
        <div><span className="text-[var(--rm-gray-500)]">Retraits </span><span className="font-semibold text-[var(--rm-red-light)]">{formatEuro(row.total_retraits)}</span></div>
        <div><span className="text-[var(--rm-gray-500)]">Théorique </span><span className="font-semibold">{formatEuro(row.total_theorique)}</span></div>
        <div><span className="text-[var(--rm-gray-500)]">Comptable </span><span className="font-semibold">{formatEuro(row.total_comptable)}</span></div>
        <div><span className="text-[var(--rm-gray-500)]">Validé </span><span className="text-[var(--rm-gray-300)]">{row.validated_by || '—'}</span></div>
      </div>

      <div className="flex flex-wrap gap-2">
        {['ouverture', 'fermeture', 'rapport', 'ventes'].map((type) => (
          <button
            key={type}
            type="button"
            onClick={() => actions.printMonthly(type, row.id)}
            className="btn-secondary px-3 py-2 min-h-[44px] text-xs capitalize"
            data-testid={`${testIdPrefix}-month-${type}-${row.id}`}
          >
            {type === 'rapport' ? 'Caisse' : type === 'ventes' ? 'Ventes jour' : type}
          </button>
        ))}
      </div>
    </article>
  );
}
